module.exports = __webpack_public_path__ + "static/media/text-allign-center.914c36a3.svg";